// extracted by mini-css-extract-plugin
export default {"root":"Link-modules__root__SXIcl","show-keyframe":"Link-modules__show-keyframe__IzyLP"};